import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AccessLevel } from '../../../../constants/AccessLevels';

import Widget from '../../Widget/Widget';

import { Col, Row } from 'reactstrap';

import axios from 'axios';
import { setNewCancelToken, setViewTimespan } from '../../../../redux/actions/general';
import { cancelTokenSelector } from '../../../../redux/selectors/selectors';
import { MISUSE_VIEW } from '../../../../constants/general';
import MisuseContainer from '../../../widgets/misuse/MisuseContainer';

function Misuse({ location, history }) {
   const cancelToken = useSelector(cancelTokenSelector);
   const cancelTokenRef = useRef(cancelToken);
   cancelTokenRef.current = cancelToken;

   const dispatch = useDispatch();

   useEffect(() => {
      return () => {
         // cancel token, added to old requests, will be activated --> old requests will be cancelled
         cancelTokenRef.current.cancel('Operation canceled by the user.');
         dispatch(setViewTimespan(MISUSE_VIEW));
         dispatch(setNewCancelToken(axios.CancelToken.source()));
      };
   }, [dispatch]);

   return (
      <Row className='animated fadeIn'>
         <Col xs='12' sm='12' md='12' lg='12' xl='12'>
            <Widget type={MisuseContainer} requiredLevel={AccessLevel.FULL} widgetAttributes={{ location, history }} />
         </Col>
      </Row>
   );
}

export default Misuse;
